/**
 * The page's copy, as data.
 *
 * The words live in git, where they get reviewed, diffed and blamed like anything else.
 * There was a second arm here and a `homeroom_landing_copy` experiment to choose between
 * them; the experiment was never created in any console, so every visitor has always
 * seen this one. It was retired with Statsig on 2026-09-14 — git history holds the other
 * arm if the question is ever worth asking properly.
 *
 * Voice note for whoever edits these: use contractions. 240's site writes "we've" and
 * "you'll"; the documents in this repo deliberately do not, and that register keeps
 * leaking in here where it does not belong.
 */

export interface Copy {
  /** Rides on every funnel event as `experiment_variant`, labelling which page sent it. */
  variant: string;
  headline: string;
  paragraphs: string[];
  /** Emphasised lead-in on the final line, immediately above the form. */
  ctaLead: string;
  ctaBody: string;
}

/** What the legacy notify page ships. Sam's wording, 2026-08-19. */
export const CLASSROOM: Copy = {
  variant: 'classroom',
  headline: 'The classroom is where the real work starts.',
  paragraphs: [
    "We've helped more than half a million teachers pass their certification exams. Then you get your own classroom — and studying was never the hard part. The hard part is everything the job piles on after the bell.",
    "240 Labs is where we're building tools for that: software that takes work off your plate instead of adding to it. Teachers have always come to us to learn; this time, you're the teacher. We'll build with you, test with you, and only ship what actually gives you time back.",
  ],
  ctaLead: 'Be first in line',
  ctaBody:
    "Drop your email and you'll see everything before anyone else — and we'll ask what you think along the way.",
};

/** The copy the page ships. */
export const DEFAULT_COPY = CLASSROOM;
